import _defineProperty from "/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as sentryTypes from "@sentry/types";
var sentryTypeKeys = ["Severity", "SeverityLevels"];
var wrapSentrySdkKeys = ["init", "onLoad", "addBreadcrumb", "captureEvent", "captureException", "captureMessage", "configureScope", "showReportDialog", "withScope"];

function createSentryClient() {
  var wrappedClient = wrapSentrySdkKeys.reduce(function (acc, key) {
    acc[key] = function () {
      if (typeof window === "undefined") return;

      if (Object(window.Sentry || {}).hasOwnProperty(key)) {
        var _window$Sentry;

        (_window$Sentry = window.Sentry)[key].apply(_window$Sentry, arguments);
      }
    };

    return acc;
  }, {});
  var types = sentryTypeKeys.reduce(function (collection, typeKey) {
    Object.defineProperty(collection, typeKey, {
      value: sentryTypes[typeKey],
      writable: false,
      enumerable: true
    });
    return collection;
  }, {});
  return Object.freeze(_objectSpread(_objectSpread({}, wrappedClient), types));
}

export var Sentry = createSentryClient();